import { color } from '@upstox/upstox-ui';

export const rowContainer: CSSFunction = ({ theme }) => ({
  height: 36,
  background: theme.colors.background.default,
});

export const optionChainTableHeaderCell: CSSFunction<{
  isLtpCell: boolean;
}> = ({ theme, cssProps }) => {
  const { isLtpCell } = cssProps;
  return {
    padding: '0 8px',
    ...(isLtpCell && { padding: '0 40px' }),
    verticalAlign: 'middle',
    color: color(theme, theme.colors.text[2]),
    fontFamily: 'Messina Sans',
    boxShadow: `inset 0 -1px 0 ${color(theme, theme.colors.ui3)}`,
  };
};

export const actionCell: CSSFunction<{
  isCall: boolean;
}> = ({ cssProps }) => ({
  position: 'sticky',
  ...(cssProps.isCall ? {
    right: 0,
  } : {
    left: 0,
  }),
  width: 0,
  minWidth: 0,
  padding: 0,
  zIndex: 5,
  overflow: 'visible',
});
